export const domain: string = import.meta.env.VITE_AUTH0_DOMAIN ?? ''
export const clientID: string = import.meta.env.VITE_AUTH0_CLIENT_ID ?? ''
export const baseUrl: string = import.meta.env.VITE_BASE_API_URL ?? ''
export const homeUrl: string = import.meta.env.VITE_HOME_URL ?? ''
export const payeClientKey: string = import.meta.env.VITE_PAYE_CLIENT_KEY ?? ''
